import React from "react"
import { WhyAionContainer, Wrapper, MainContent } from "./styles"
import { renderHTML } from "../../agility/utils"
import { Row, Col } from "react-bootstrap"
import WhyAionWaves from "../../img/why_aion_waves.svg"

const WhyAion = ({ item }) => {
  return (
    <WhyAionContainer img={WhyAionWaves}>
      <Wrapper>
        <MainContent>
          <h3>{item.customFields.title}</h3>
          <div
            className="main-text"
            dangerouslySetInnerHTML={renderHTML(item.customFields.text)}
          />
          <Row>
            <Col lg={3} md={6}>
              <img
                src={item.customFields.point1Icon.url}
                alt={item.customFields.point1Icon.label}
              />
              <p>{item.customFields.point1Text}</p>
            </Col>
            <Col lg={3} md={6}>
              <img
                src={item.customFields.point2Icon.url}
                alt={item.customFields.point2Icon.label}
              />
              <p>{item.customFields.point2Text}</p>
            </Col>
            <Col lg={3} md={6}>
              <img
                src={item.customFields.point3Icon.url}
                alt={item.customFields.point3Icon.label}
              />
              <p>{item.customFields.point3Text}</p>
            </Col>
            <Col lg={3} md={6}>
              <img
                src={item.customFields.point4Icon.url}
                alt={item.customFields.point4Icon.label}
              />
              <p>{item.customFields.point4Text}</p>
            </Col>
          </Row>
          <p className="resource">
            <a
              href={item.customFields.resource}
              target="_blank"
              rel="noopener noreferrer"
            >
              {item.customFields.resource}
            </a>
          </p>
        </MainContent>
      </Wrapper>
    </WhyAionContainer>
  )
}

export default WhyAion
